import { useState } from 'react'
import { Trans } from 'react-i18next'

import { Erase16 } from '@makyoapp/makyo-icon/icon'

import { ModalClearRows } from '../Modal/ModalClearRows'

export const ClearRows = () => {
  const [show, setShow] = useState(false)

  return (
    <>
      <button onClick={() => setShow(true)} className='mk-ddi flex-c red mk-dd-row'>
        <Erase16 />
        <div>
          <Trans>Clear Rows</Trans>
        </div>
      </button>
      <ModalClearRows show={show} setShow={setShow} />
    </>
  )
}
